import { Dnc } from '@Containers/Dnc';

const DncPage: React.FunctionComponent = (): JSX.Element => <Dnc />;

export default DncPage;
